module.exports = __webpack_public_path__ + "img/web.a64f0fb4.png";